import FactoryBox from './View/FactoryBox.view';
export default FactoryBox;
